import React, { useCallback } from 'react'
import { useIntl } from 'react-intl'
import BodyText from 'LuxKit/Typography/BodyText'
import { BnblSteps } from 'components/OfferPage/BnblModal/utils'
import Group from 'components/utils/Group'
import Select from 'components/Common/Form/Input/Select'

interface Props {
  duration: number
  setStep: (step: BnblSteps) => void
}

export function BnblPackageDuration({ duration, setStep }: Props) {
  const intl = useIntl()
  const onChangeDuration = useCallback(() => {
    setStep(BnblSteps.CHANGE_DURATION)
  }, [setStep])

  return (
    <Group direction="horizontal" horizontalAlign="space-between" verticalAlign="center">
      <BodyText variant="large" weight="bold">{intl.formatMessage({
        id: '++dUqX35zS',
        defaultMessage: 'Length of stay',
        description: 'Label for the duration selector in BNBL package configuration',
      })}
      </BodyText>
      <Select
        value={intl.formatMessage(
          {
            id: 'hbLQpMhGLU',
            defaultMessage: '{nights, plural, one {# night} other {# nights}}',
            description: 'Duration value for BNBL package duration selector',
          },
          { nights: duration },
        )}
        onClick={onChangeDuration}
        onMouseDown={e => e.preventDefault()}
        noValidationSpacing
      >
        <option>{intl.formatMessage(
          {
            id: 'hbLQpMhGLU',
            defaultMessage: '{nights, plural, one {# night} other {# nights}}',
            description: 'Duration value for BNBL package duration selector',
          },
          { nights: duration },
        )}
        </option>
      </Select>
    </Group>
  )
}
